import type { ContactSupportInput } from 'src/graphql/entities/contact-support';
import type { LinkConversationOption } from './search-conversation-field';

export enum ContactSupportFormField {
  IssueType = 'issueType',
  Subject = 'subject',
  AdditionalContext = 'additionalContext',
  Attachments = 'attachments',
  LinkedConversation = 'linkedConversation',
}

export interface ContactSupportFormValues {
  [ContactSupportFormField.IssueType]: ContactSupportInput['issueType'];
  [ContactSupportFormField.Subject]: ContactSupportInput['subject'];
  [ContactSupportFormField.AdditionalContext]: ContactSupportInput['additionalContext'];
  [ContactSupportFormField.Attachments]: FileList | null;
  [ContactSupportFormField.LinkedConversation]: LinkConversationOption | null;
}
